/* ============================================================
   ATELIER OVIA LAUNCH HERO - behaviour, ported from the approved
   harness (2026-07-24). Runs the ~9.5s shot sequence + finish
   cascade, then settles: dots become the interactive finish
   swapper (tower pattern) and the replay button appears.
   Debug: ?end=1 jumps to the settled frame (also the
   prefers-reduced-motion path); ?spd= scales the timeline
   (e.g. ?spd=0.4 = slower). Self-contained.
   ============================================================ */
(function () {
  'use strict';
  var omh = document.querySelector('.omh');
  if (!omh || omh.dataset.omhInit) return;
  omh.dataset.omhInit = '1';

  var cap = omh.querySelector('.omh-cap'),
      capN = omh.querySelector('.omh-cap-n'),
      capF = omh.querySelector('.omh-cap-f span'),
      dots = omh.querySelector('.omh-dots');

  var FIN = {
    bg: { n: 'Brushed Gold', ac: '#C5A253' },
    cm: { n: 'Champagne', ac: '#DDB3AE' },
    bn: { n: 'Warm Brushed Nickel', ac: '#CFC4B0' },
    cr: { n: 'Chrome', ac: '#C8D2DA' },
    gm: { n: 'Gun Metal', ac: '#9C958C' },
    mb: { n: 'Matte Black', ac: '#7E7A75' }
  };
  var SHOTS = [
    { sel: '.omh-s1', name: 'Tall Basin Mixer', fin: 'bg' },
    { sel: '.omh-s2', name: 'Kitchen Mixer', fin: 'cm' },
    { sel: '.omh-s3', name: 'Twin Shower', fin: 'cr' },
    { sel: '.omh-s4', name: 'Tall Basin Mixer', fin: 'mb' }
  ];
  var CASCADE = ['mb', 'gm', 'cr', 'bn', 'cm', 'bg'];

  var qs = new URLSearchParams(location.search);
  var SPD = parseFloat(qs.get('spd')) || 1; /* <1 = slower */
  var timers = [];
  function at(t, fn) { timers.push(setTimeout(fn, t / SPD)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  omh.style.setProperty('--spd', String(1 / SPD));

  function swapCap(name, fin) {
    capN.textContent = name;
    capF.textContent = FIN[fin].n;
    cap.classList.remove('swap'); void cap.offsetWidth; cap.classList.add('swap');
  }
  function setAc(fin) { omh.style.setProperty('--ac', FIN[fin].ac); }

  function setShot(i) {
    var sh = SHOTS[i];
    /* drop the CSS-only boot state in the SAME synchronous block that adds .on,
       so scene 1 is never left unpainted for a frame during the handover */
    omh.classList.remove('omh-boot');
    omh.querySelectorAll('.omh-shot').forEach(function (s) {
      s.classList.toggle('on', s.matches(sh.sel));
    });
    setAc(sh.fin);
    swapCap(sh.name, sh.fin);
    omh.classList.toggle('cascade', sh.sel === '.omh-s4');
  }
  function setFinish(f, quiet) {
    omh.querySelectorAll('.omh-cf').forEach(function (el) { el.classList.toggle('on', el.dataset.f === f); });
    omh.querySelectorAll('.omh-cbloom').forEach(function (el) { el.classList.toggle('on', el.dataset.f === f); });
    dots.querySelectorAll('i').forEach(function (d) { d.classList.toggle('on', d.dataset.f === f); });
    omh.classList.toggle('mb-deep', f === 'mb');
    setAc(f);
    capF.textContent = FIN[f].n;
    if (!quiet) { cap.classList.remove('swap'); void cap.offsetWidth; cap.classList.add('swap'); }
  }

  function run() {
    clearTimers();
    omh.classList.remove('play', 'is-done', 'cascade', 'mb-deep', 'glint-done');
    omh.querySelectorAll('.omh-shot').forEach(function (s) { s.classList.remove('on'); });
    void omh.offsetWidth;
    omh.classList.add('play');
    at(50, function () { setShot(0); });
    at(2600, function () { setShot(1); });
    at(5000, function () { setShot(2); });
    at(7400, function () { setShot(3); setFinish('mb', true); });
    var t = 7850;
    CASCADE.slice(1).forEach(function (f) {
      at(t, function () { setFinish(f); }); t += 400;
    });
    at(t + 350, function () { omh.classList.add('is-done'); });
  }
  function jumpEnd() {
    clearTimers();
    omh.classList.add('play', 'is-done');
    omh.classList.remove('mb-deep');
    setShot(3); setFinish('bg', true);
  }

  /* dots interactive after settle */
  dots.querySelectorAll('i').forEach(function (d) {
    var pick = function (e) {
      if (!omh.classList.contains('is-done')) return;
      if (e.type === 'click') e.preventDefault();
      setFinish(d.dataset.f);
    };
    d.addEventListener('pointerenter', pick);
    d.addEventListener('click', pick);
    d.addEventListener('focus', pick);
  });

  omh.querySelector('.omh-replay').addEventListener('click', run);

  /* perf: once the settle glint's sweep ends, glint-done drops its
     blend/mask layer from the compositor (nothing visible remains) */
  omh.querySelector('.omh-s4 .omh-glint i').addEventListener('animationend', function () {
    if (omh.classList.contains('is-done')) omh.classList.add('glint-done');
  });

  /* perf: freeze the whole stage while the band is out of the viewport -
     as the default banner it otherwise animates for the entire session
     after the user scrolls past (CSS .omh-off pauses every animation) */
  new IntersectionObserver(function (entries) {
    omh.classList.toggle('omh-off', !entries[0].isIntersecting);
  }, { rootMargin: '80px' }).observe(omh);

  var reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (reduced || qs.get('end') === '1') { jumpEnd(); return; }

  /* start once the opening frame is ready (2.5s cap) */
  var first = omh.querySelector('.omh-s1 img');
  var started = false, start = function () { if (started) return; started = true; run(); };
  if (first.complete) start();
  else { first.addEventListener('load', start); setTimeout(start, 2500); }
})();
